import { FC } from 'react';

/**
 * Inline spinner component
 * Used for button loading states and inline loading indicators
 */
interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'white' | 'gray' | 'primary';
  className?: string;
}

export const Spinner: FC<SpinnerProps> = ({ 
  size = 'md', 
  color = 'gray',
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-6 h-6 border-2',
    lg: 'w-8 h-8 border-3',
  };

  const colorClasses = {
    white: 'border-white/30 border-t-white',
    gray: 'border-gray-200 border-t-gray-900',
    primary: 'border-gray-200 border-t-gray-900',
  };

  return (
    <div
      className={`${sizeClasses[size]} ${colorClasses[color]} rounded-full animate-spin ${className}`}
      role="status"
      aria-label="Loading"
    />
  );
};

